/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Moment from 'moment';
import { COMMON, API_CONSTANTS, ALL_ROUTES } from '../../global/Constants';
import { HeaderTypes, ActivityType, HomeActivityType } from "../../global/Enum";
//import './activity-calendar.css';
import Header from '../common/Header';
import Footer from '../common/Footer';
import DesktopFooter from '../common/DesktopFooter';
//import ApiServices from "../../providers/ApiServices";
import Loader from "../common/loader/Loader";
import Utilities from '../../global/Utilities';
//import AcceptRejectButton from '../common/AcceptRejectButton';
import ActivityHeader from '../common/ActivityHeader';
import SyncServices from '../../providers/SyncServices';
import DataProvider from '../../providers/DataProvider';
import IndividualVisitView from './IndividualVisitView';
import SampleDistributionView from './SampleDistributionView';
import SyncLoader from '../common/loader/SyncLoader';

class ActivityDetailsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isFarmer: true,
            activity: null,
            data: null,
            address: "Fetching address...",
            user: {}
        }
    }


    async componentDidMount() {
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            await DataProvider.getInstance().fetchMasterData();

            if (this.props.location.state !== undefined) {
                let activity = this.props.location.state.activity;
                Utilities.LogPrint("Data:-->", activity);
                this.setState({ activity: activity });
                this.getActivityById(activity.key);

                if (activity.retailer_id === 0) {
                    this.getKrishakById(activity.krishak_id);
                } else {
                    this.getRetailerById(activity.retailer_id);
                }

            } else {
                this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    //Offline
    getActivityById = (activityId) => {
        // For Check Added by Krunal
        this.setState({ isLoading: true });

        SyncServices.getActivityById("key", activityId).then(activity => {
            Utilities.LogPrint("getActivityById ===========", activity);
            this.setState({ isLoading: false });
            //const data = activity?.data;

            this.setState({ data: activity });
        });
    }

    getKrishakById = (krishak_id) => {
        //Utilities.LogPrint("krishak_id", krishak_id);
        SyncServices.findKrishakFromDatabase("krishak_id", String(krishak_id)).then(data => {
            if (data) {
                Utilities.LogPrint("getKrishakFromDatabase", data);
                if (data.is_active === undefined || data.is_active === null || data.is_active === 1) {
                    //const krishakInfo = data;

                    let user = { name: data.name, phone: data.phone }
                    this.setState({
                        user: user
                    });
                } else {
                    //this.checkKrishakOffline(krishak_id);
                }
            } else {
                Utilities.LogPrint("getKrishakFromDatabase", "no");
                //this.checkKrishakOffline(krishak_id);
            }
        });
    }

    getRetailerById = (retailerId) => {
        const retailersArray = DataProvider.getInstance().getRetailers();
        //Utilities.LogPrint("Retailers", retailersArray);
        if (retailersArray) {
            const item = retailersArray.find(item => item.retailer_id === retailerId);
            if (item) {
                //Utilities.LogPrint("Retailer", item);
                let user = { name: item.retailer_name, phone: item.phone }
                this.setState({ user: user });
            }
        }
    }

    getEmployeeNameById = (userId) => {
        const employee = DataProvider.getInstance().getEmployeeById(userId);
        if (employee) {
            return employee.name;
        }
        return "";
    }


    handleBack = () => {
        this.props.history.goBack();
    }

    getFormattedDate(date) {
        return Moment(new Date(date)).format('dddd, DD MMM, yyyy');
        //return Moment(new Date()).format('dddd, DD MMM, yyyy');
    }

    getActivityName = (type) => {
        const { activity } = this.state;
        if (type === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id === 0) {
            return HomeActivityType.INDIVIDUAL_VISIT_FARMER;

        } else if (type === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id !== 0) {
            return HomeActivityType.INDIVIDUAL_VISIT_RETAILER;

        } else if (type === ActivityType.SAMPLE_DISTRIBUTION) {
            return HomeActivityType.SAMPLE_DISTRIBUTION;

        } else if (type === ActivityType.GROUP_MEETING) {
            return HomeActivityType.GROUP_MEET;
        }

        return "";
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isLoading, isSyncLoading, tableName, activity, data, user } = this.state;

        if (data == null) {
            return (
                <div>
                    {isLoading ? <Loader /> : null}
                </div>
            );
        }

        return (
            <div>
                <Header selectedTab={HeaderTypes.TODAY} handleSyncLoading={this.handleSyncLoading} />
                <Footer isActive={2} />

                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-12">
                            <h3 className="title mb-3">{this.getFormattedDate(data?.created_at)} Activities for {this.getEmployeeNameById(activity.assigned_user_id)}</h3>
                            {/* <p className="sub-title">{activity?.tehsil_name}</p> */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-6 col-lg-7 col-md-9 col-12">
                            <ActivityHeader
                                type={activity.activity_type_id}
                                code={activity?.activity_tag}
                                title={this.getActivityName(activity.activity_type_id)}
                                subTitle={activity?.crop_name + ", " + activity?.hybrid_name + " | " + activity?.village_name} />

                            {/* <div className="activity-info-box brown-activity mb-3 text-white max-w-460 my-3">
                                <span>SD2712</span>
                                <h5>Sample Distribution</h5>
                                <span>CROP, HYBRID | Village</span>
                            </div> */}

                        </div>
                        <div className="col-xl-6 col-lg-5 col-md-3 d-md-flex back-btn mt-3 d-none">
                            <button className="btn btn-secondary min-w-182 krishak-cancel-btn" onClick={this.handleBack}>{COMMON.BACK}</button>
                        </div>
                    </div>

                    {activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT ?
                        <IndividualVisitView activity={data} user={user} /> : null
                    }

                    {activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION ?
                        <SampleDistributionView activity={data} user={user} /> : null
                    }

                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                <DesktopFooter />
            </div>
        )
    }

}

export default withRouter(ActivityDetailsPage);